import { EXPORT_TYPE } from '../constants/shoppinglist.constant'
import TrackProAPI from './track-pro-api'

export const addToShoppingList = (part_id: number) => {
    return TrackProAPI.post('/assets/shopping/add', { part_id })
}

export const clearShoppingList = () => {
    const endpoint = '/assets/shopping/clear'
    return TrackProAPI.post(endpoint)
}

export const getShoppingList = () => {
    return TrackProAPI.get('/assets/shopping/get')
}

export const deleteShoppingListItem = (item_id: number) => {
    return TrackProAPI.post('/assets/shopping/remove', { item_id })
}

export const exportShoppingList = (type: string) => {
    const endpoint =
        type == EXPORT_TYPE.CSV
            ? '/assets/shopping/export-csv'
            : '/assets/shopping/export-pdf'
    return TrackProAPI.get(endpoint, { responseType: 'blob' })
}

export const emailShoppingList = (email: string) => {
    const endpoint = `/assets/shopping/export-email?email=${email}`
    return TrackProAPI.get(endpoint)
}

export const updateQuantity = (item_id: number, quantity: number) => {
    const endpoint = '/assets/shopping/update'
    return TrackProAPI.post(endpoint, { item_id, quantity })
}
